const SESSION_INVALID = {
  CODE: "OTSS000",
  MESSAGE: "SESSION_EXPIRED",
} as const;

export default { SESSION_INVALID };
